export * from './config';
export * from './feature_flags';
export * from './htmlAnchorPositions';
export * from './programs';
export * from './storage';
export * from './users';

export const VideoExts = ['mp4', 'mov', 'webm', 'm4v'];
export const ImageExts = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'svg'];
